import {JSX, useEffect} from "react";
import {$insertNodes, createCommand, LexicalCommand, COMMAND_PRIORITY_EDITOR} from "lexical";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {$createImageNode} from "@common/components/forms/rich-text-form-field/nodes/image-node";

export const INSERT_IMAGE_COMMAND: LexicalCommand<{ src: string; altText?: string }> =
    createCommand("INSERT_IMAGE_COMMAND");

export default function ImagePlugin(): JSX.Element | null {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerCommand(
            INSERT_IMAGE_COMMAND,
            (payload) => {
                const {src, altText} = payload;

                editor.update(() => {
                    const node = $createImageNode({src, altText});
                    $insertNodes([node]);
                });

                return true;
            },
            COMMAND_PRIORITY_EDITOR
        );
    }, [editor]);

    return null;
}
